<template>
  <div class="mobile-page-caseinfo" style="background: #0d0d0d">
    <div class="mobile-caseinfo-content">
      <div class="mobile-crumbs-box">
        首页 > 全部案例 > <span>{{ infoData.title }}</span>
      </div>
      <!-- <div class="mobile-img"></div> -->
      <img :src="getImgUrl(infoData.thumb)" alt="" class="mobile-icon" />
      <div class="mobile-title">{{ infoData.title }}</div>
      <div class="mobile-text">{{ infoData.describe || "" }}</div>
      <!-- <div class="mobile-img"></div>
      <div class="mobile-img2"></div> -->
      <div v-html="cleanHtmlText(infoData.content)"></div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Footer from "@/components/MobileIframe/components/Footer";
import { pageApi } from "@/api";
export default {
  components: { Footer },
  data() {
    return {
      infoData: {},
    };
  },
  mounted() {
    this.initData();
  },
  methods: {
    initData() {
      pageApi.getCaseDetail({ id: this.$route.query.id }).then((res) => {
        this.infoData = res.result;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import url("./index.scss");
</style>
